<template>
  <div class="energyTreeMenu">
    <el-radio-group
      v-model="typeFiltering"
      @change="changetypeFiltering"
      size="small"
    >
      <el-radio-button label="分项系统">系统</el-radio-button>
      <el-radio-button label="区域位置">区域</el-radio-button>
      <el-radio-button label="单位部门">部门</el-radio-button>
    </el-radio-group>
    <el-row>
      <el-radio-group
        v-model="activeType"
        size="mini"
        style="margin-top: 20px"
        @change="handleTimeChage"
      >
        <el-radio v-for="v in energyTypeList" :key="v.key" :label="v.key">{{
          v.name
        }}</el-radio>
      </el-radio-group>
    </el-row>

    <div class="timeBox">
      <el-select
        v-model="timeType"
        placeholder="请选择"
        style="width: 25%"
        size="small"
        @change="getDataValue"
      >
        <el-option
          v-for="v in defaultTimeList"
          :key="v.value"
          :label="v.label"
          :value="v.value"
        >
        </el-option>
      </el-select>
      <template v-if="timeType !== 'UNLIMITED'">
        <el-date-picker
          size="small"
          v-model="timeValue"
          :clearable="false"
          :type="
            timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
          "
          :key="
            timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
          "
          :value-format="
            timeType == 'YEAR'
              ? 'yyyy'
              : timeType == 'MONTH'
              ? 'yyyy-MM'
              : 'yyyy-MM-dd'
          "
        >
        </el-date-picker>
      </template>
    </div>
    <div style="width: 100%; height: 70%; margin: 10px 0 20px 0">
      <el-input placeholder="请输入关键字" v-model="filterText"> </el-input>
      <el-tree
        :data="dataList"
        :props="defaultProps"
        node-key="id"
        highlight-current
        accordion
        :default-expanded-keys="defaultKeys"
        :filter-node-method="filterNode"
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
          height: 80%;
        "
      >
      </el-tree>
    </div>
    <div class="btnBox">
      <el-button type="primary" icon="el-icon-search" @click="onSubmit"
        >搜索</el-button
      >
      <el-button @click="resetting">重置</el-button>
    </div>
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
import api from "@/api";
export default {
  props: {
    timeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      typeFiltering: "分项系统",
      timeType: "",
      timeValue: new Date(),
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      dataList: [],
      treeAllData: [], //全部树数据
      defaultKeys: [], //默认打开
      energyTypeList: [],
      activeType: "",
      defaultTimeList: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    handleTimeChage() {
      this.$store.commit("SET_LOADING", true);
      if (this.activeType == "power") {
        if (this.timeList.length) {
          this.defaultTimeList = JSON.parse(JSON.stringify(this.timeList));
        } else {
          this.defaultTimeList = [
            { label: "日", value: "DAY" },
            { label: "月", value: "MONTH" },
            { label: "年", value: "YEAR" },
            { label: "全部", value: "UNLIMITED" },
          ];
        }
      } else {
        if (this.$route.path == "/equipmentConsume") {
          this.defaultTimeList = [
            { label: "日", value: "DAY" },
            { label: "月", value: "MONTH" },
            { label: "年", value: "YEAR" },
          ];
        } else {
          this.defaultTimeList = [
            { label: "月", value: "MONTH" },
            { label: "年", value: "YEAR" },
          ];
        }
      }

      if (
        this.$route.path == "/equipmentConsume" &&
        this.activeType != "power"
      ) {
        this.timeType = this.defaultTimeList[1].value;
      } else {
        this.timeType = this.defaultTimeList[0].value;
      }

      this.getDataValue();
      this.getTreeData();
    },
    changeECType() {},
    onSubmit() {
      if (this.timeType != "UNLIMITED" && !this.timeValue) {
        this.$message.error("请选择时间");
        return;
      }
      if (!this.$refs.tree.getCurrentKey()) {
        this.$message.error("请选择资产");
        return;
      }
      let obj = this.energyTypeList.find((v) => {
        return v.key === this.activeType;
      });
      let data = {
        assetId: this.$refs.tree.getCurrentKey(),
        type: this.timeType,
        date: this.timeValue,
        label: this.typeFiltering,
        name: this.$refs.tree.getCurrentNode(),
        activeType: this.activeType,
        deviceType: obj.deviceTypes ?? "",
        allTreeData: this.dataList,
      };
      this.$emit("getTreeActive", data);
    },
    resetting() {
      this.typeFiltering = "分项系统";
      this.activeType = this.energyTypeList[0]?.key ?? "power";
      this.handleTimeChage();
      this.changetypeFiltering("resetting");
    },
    changetypeFiltering(type) {
      this.dataList = this.treeAllData[this.typeFiltering]
        ? [this.treeAllData[this.typeFiltering]]
        : [];
      this.filterText = "";
      this.$refs.tree.setCurrentKey();
      this.defaultKeys = [];
      if (this.dataList.length == 0) {
        this.$message.warning("未查询到资产");
        return;
      }
      if (type == "resetting") {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.dataList[0].id);
          this.defaultKeys.push(this.dataList[0].id);
        });
      }
    },
    getDataValue() {
      if (this.timeType == "YEAR") {
        this.timeValue = dateFtt("yyyy", new Date());
      } else if (this.timeType == "MONTH") {
        this.timeValue = dateFtt("yyyy-MM", new Date());
      } else if (this.timeType == "DAY") {
        this.timeValue = dateFtt("yyyy-MM-dd", new Date());
      } else {
        this.timeValue = null;
      }
    },

    async getTreeData() {
      this.treeAllData = [];
      let obj = this.energyTypeList.find((v) => {
        return v.key === this.activeType;
      });

      let res = await api.lightSystemAssetsTreeMenu({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectName,
        option: "HasEUDevice",
        deviceType: obj.deviceTypes ?? "",
        relationType:
          this.$route.path == "/equipmentConsume" ||
          this.$route.path == "/eCAnalysis"
            ? "Contains"
            : "SubDelegates",
      });
      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.treeAllData = res.data.assets;
        this.dataList = this.treeAllData[this.typeFiltering]
          ? [this.treeAllData[this.typeFiltering]]
          : [];
        if (this.dataList.length == 0) {
          this.$message.warning("未查询到资产");
          return;
        }
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.dataList[0].id);
          this.defaultKeys.push(this.dataList[0].id);
          let data = {
            assetId: this.$refs.tree.getCurrentKey(),
            type: this.timeType,
            date: this.timeValue,
            label: this.typeFiltering,
            name: this.$refs.tree.getCurrentNode(),
            activeType: this.activeType,
            deviceType: obj.deviceTypes ?? "",
            allTreeData: this.dataList,
          };
          this.$emit("getTreeActive", data);
        });
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  created() {
    this.energyTypeList = JSON.parse(
      window.sessionStorage.getItem("energyType")
    );
    this.activeType = this.energyTypeList[0]?.key ?? "power";
    this.handleTimeChage();
  },
};
</script>

<style lang="scss" scoped>
.energyTreeMenu {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  overflow: auto;
  ::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }
  .timeBox {
    margin: 20px 0;
    @include setFlexBetween;
  }
  .btnBox {
    @include setFlexCenter;
  }
}
</style>
